angular.module('impactx.basket').component('ixBasketDatesInput', {
    bindings: {
        date: '<',
        sendDistributionList: '<',
        firstDate: '<',
        lastDate: '<',
        headline: '@',
        openDialog: '&',
        remove: '&'
    },
    templateUrl: 'modules/basket/templates/basket-date-input.tmpl.html'
});